import { IApiConfig } from "./types";

/**
 * @internal
 */
export const _configuration: IApiConfig = {};

/**
 * Get the current configuration
 * @returns Active configuration, a combination of what the game has sent with [[configure]] and what the operator
 * environment supports.
 */
export const getConfiguration = (): IApiConfig =>
{
    return _configuration;
};

export const getTargetOrigin = (): string =>
{
    if (_configuration.clientConfig) {
        return _configuration.clientConfig.targetOrigin ?? "*";
    }

    if (_configuration.p2pConfig) {
        return _configuration.p2pConfig.targetOrigin ?? "*";
    }

    // This will throw an error, but it's OK - getTargetOrigin should never be called before we have received config
    return "-";
};

/**
 * 
 * @returns True if targetOrigin is configured (if set)
 */
export const isTargetOriginReceived = (): boolean =>
{
    return _configuration.clientConfig !== undefined || _configuration.p2pConfig !== undefined;
};

export const isHandshakeDone = (): boolean =>
{
    return _configuration.operatorHandlesErrors !== undefined;
};